import { OptimizedValueExpressionsBase } from './OptimizedValueExpressionsBase';
import { Scope, SetValues } from './OptimizedValueExpressionTypes';

/**
 * To optimized performance, when a ScanTemplatePart has no expressions, we can just return the parent's scope as this part's scope
 */
export class OptimizedValueExpressionsWithJustScope implements OptimizedValueExpressionsBase {
  constructor(readonly scope: Scope) {}
  get resolved() {
    return this.scope;
  }
  get calculatedValues() {
    return this.scope;
  }
  validateAllDependenciesDefined(): void {}
  withNewScope(scope: Scope, setValues?: SetValues): OptimizedValueExpressionsBase {
    return new OptimizedValueExpressionsWithJustScope(scope);
  }

  getPlainObjects() {
    return {
      class: 'OptimizedValueExpressionsWithJustScope',
      scope: this.scope,
    };
  }
}
